import { render, staticRenderFns } from "./WorkInvitationBlock.vue?vue&type=template&id=134313a0&scoped=true&"
import script from "./WorkInvitationBlock.vue?vue&type=script&lang=js&"
export * from "./WorkInvitationBlock.vue?vue&type=script&lang=js&"
import style0 from "./WorkInvitationBlock.vue?vue&type=style&index=0&id=134313a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134313a0",
  null
  
)

export default component.exports